<template>
    <div
      ref="container_div"
      :class="{
        'show_mode' : 'show' == mode && hasVisibleFormType,
        'taojin-ticket-form-inline': false
      }">

      <template v-if="ticketTaskFormData && ticketTaskFormData.length > 0">
        <div v-if="fullScreen || isNowFullScreen"
          class="title_bar_1">
          <span style="padding-left:20px;font-weight:600;color:#555;">表单</span>

          <span
            @click="doFullScreen"
            title="最大化/还原 这个表单[13]"
            class="el-icon-copy-document full-screen-btn"/>

          <span
            @click="do_minimize_form"
            title="最小化/还原 这个表单[19]"
            class="el-icon-minus form-minimize-btn"/>

          <!-- <FormInlineMode v-model="formInline"/> -->
        </div>

        <el-form
          label-width="80px"
          label-position="top"
          class="ticket_form"
          :class="{
            'ticket_form_new' : 'new' == mode && !isNowFullScreen,
            'ticket_form_edit' : 'edit' == mode,
            'ticket_form_show' : 'show' == mode
          }">
            <!-- 没有需要填写的表单 -->
            <div v-if="'edit' == mode && !hasVisibleFormType"
              style="text-align:center;font-size:35px;padding-top:45px;color:#EEE;">没有需要填写的表单</div>

            <template v-for="e in ticketTaskFormData">
              <template v-if="'allow_deny'==e.type"/> <!-- 特殊表单表单,展示为两个按钮 -->

              <el-form-item
                v-else
                :title="e.name + ' ' + e.id"
                :key="e.id"
                :class="{
                  'ticket_form_item' : !isVertical(e),
                  'ticket_form_item_vertical' : isVertical(e),
                  'ticket_form_item_new':'new' == mode,
                  'ticket_form_item_divider': isDivider(e)
                }">

                <div slot="label">
                  <!-- 必填 -->
                  <span v-if="e.required && e.required == 'true'" class="required">*</span>

                  <!-- 属性名 -->
                  <span>{{e.name}}</span>

                  <!-- 复制订单信息 -->
                  <div v-if="'order' == e.type
                    || 'order_linkage' == e.type
                    || 'order_vertical' == e.type"
                    style="display:inline;">
                    <a style="color:#5b7e94;font-size:12px;" @click="copyOrder(e)" title="点我复制">复制</a>
                    <a style="color:#5b7e94;font-size:12px;" @click="goPeople" title="点击跳转到人员初筛页">人员</a>
                    <a style="color:#5b7e94;font-size:12px;" @click="goStudy" title="点击跳转到培训计划页">培训</a>
                  </div>

                  <!-- 复制订单信息 -->
                  <div v-else-if="'merchant_order_vertical_linkage' == e.type
                    || 'merchant_order_vertical' == e.type"
                    style="display:inline;">
                    <a style="color:#5b7e94;font-size:12px;" @click="copyMerchantOrder(e)" title="点我复制 商家 店铺 订单 信息">复制</a>
                    <a style="color:#5b7e94;font-size:12px;" @click="copyMerchantOrder_order(e)" title="点我复制 订单信息">订单</a>
                    <a style="color:#5b7e94;font-size:12px;" @click="copyMerchantOrder_shop(e)" title="点我复制 店铺信息">店铺</a>
                    <a style="color:#5b7e94;font-size:12px;" @click="copyMerchantOrder_merchant(e)" title="点我复制 商家信息">商家</a>
                  </div>

                  <!-- 复制商家信息 -->
                  <div v-else-if="'merchant_linkage' == e.type
                    || 'merchant' == e.type
                    || 'merchant_vertical' == e.type"
                    style="display:inline;">
                    <a style="color:#5b7e94;font-size:12px;" @click="copyMerchant(e)" title="点我复制">复制</a>
                  </div>

                  <!-- 复制店铺信息 -->
                  <div v-else-if="'shop' == e.type
                    || 'shop_vertical' == e.type"
                    style="display:inline;">
                    <a style="color:#5b7e94;font-size:12px;" @click="copyShop(e)" title="点我复制">复制</a>
                  </div>
                </div>

                <!-- 清除 .el-form-item__label float:left -->
                <div style="clear:both;"></div>

                <TicketTaskFormItem
                  ref="ticketTaskFormItem"
                  :item = "e"
                  :fromDialog="fromDialog"
                  v-model = "properties"
                  @input = "onInput_1"
                  @change = "onChange_1"
                  :mode = "mode" />
              </el-form-item>
            </template>
        </el-form>

        <div style="clear:both;"></div>

        <div style="height:50px;margin-top:20px;" v-if="'new' == mode && !hideSubmitButtom">
          <el-button
            title="审批此工单,并提交相关表单[48]"
            type="primary"
            @click="submitAssignToWorkflow"
            style="float:right;">提交</el-button>

          <el-button
            style="float:right;margin-right:10px;" @click="onCancel">取消</el-button>
        </div>

        <div style="height:50px;margin-top:20px;" v-if="'edit' == mode">
          <el-button
            v-if="!hasAllowDeny"
            title="审批此工单,并提交相关表单[57]"
            @click="submit_1"
            type="success"
            style="float:right;">审批</el-button>

          <el-button
            v-if="hasAllowDeny"
            title="审批此工单,并提交相关表单[64]"
            @click="submitDeny"
            type="danger"
            style="float:right;">拒绝</el-button>

          <el-button
            v-if="hasAllowDeny"
            title="审批此工单,并提交相关表单[70]"
            @click="submitAllow"
            type="primary"
            style="float:right;">同意</el-button>
        </div>
      </template>

      <template v-if="!ticketTaskFormData || ticketTaskFormData.length < 1">
        <slot name="no_form"/> <!-- 扩展槽 -->
      </template>
    </div>
</template>

<script>
import AbstractTicketTaskForm from '@/assets/mixins/AbstractTicketTaskForm';
import CacheUtil from '@/assets/utils/CacheUtil';

export default {
  name: "TicketTaskForm",

  mixins : [ AbstractTicketTaskForm ] ,

  props: [
    'mode_0',
    'ticketNo_2',
    'ticketNo',
    'taskId',
    'templateId',
    'workflowId',
    'value',
    'hideSubmitButtom',
    'fullScreen',
    'fromDialog'
  ],

  data() {
    return {
      isNowFullScreen : false,
      mode : '', // show edit new
      properties : {},
      propertiesBefore : {}, // 变更前的值
      hasAllowDeny : false,
      hasVisibleFormType : false,
      formInline: CacheUtil.getFormInline() // 注意类型 bool 非 str
    };
  },

  watch : {
    formInline() {
      CacheUtil.setFormInline(this.formInline);
    },

    mode_0() {
      this.mode = this.mode_0;
    },

    value() {
      // console.log('#166 watch value', this.value, this);

      this.properties = this.value;
    },

    ticketNo() {
      this.listForm();
    },

    taskId() {
      this.listForm();
    },

    ticketNo_2() {
      this.listForm();
    },

    templateId() {
      this.listForm();
    },

    workflowId() {
      this.listForm();
    }
  },

  mounted() {
    // console.log('#193 mounted value', this.value, this.formInline, CacheUtil.getFormInline(), this);

    this.mode = this.mode_0;

    this.listForm();
  },

  methods: {
    setFormInline(_formInline) {
      this.formInline = _formInline;
    },

    getFormInline() {
      return this.formInline;
    },

    onInput_1() {
      this.onInput_TicketTaskFormItem();
    },

    onChange_1() {
      this.onChange_TicketTaskFormItemge(...arguments);
    },

    doFullScreen() {
      var _classList = this.$refs.container_div.classList;
      if ( _classList.contains('full_screen_style') ) {
        _classList.remove('full_screen_style');
        this.isNowFullScreen = false;
        return;
      }

      _classList.remove('form_minimize_style');
      _classList.add('full_screen_style');
      this.isNowFullScreen = true;
    },

    do_minimize_form() {
      var _classList = this.$refs.container_div.classList;
      if ( _classList.contains('form_minimize_style') ) {
        _classList.remove('form_minimize_style');
        return;
      }

      _classList.remove('full_screen_style');
      _classList.add('form_minimize_style');
    },

    onCancel() {
      this.$emit('cancel', null);
    },

    // 高亮他
    shadowRequiredFormItem( fieldId ) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];

        if( fieldId == each.item.id) {
          // 专门的高亮方法 1
          if ( 'summernote_vertical' == each.item.type ) {
            $(each.$el).next('.note-editor').addClass('shadow-required');
            continue;
          }

          // 专门的高亮方法 2
          if('phone_verified_vertical' == each.item.type) {
            each.shadowRequired(true);
            continue;
          }

          // 通用的高亮方法
          each.$el.classList.add('shadow-required');
        }
      }
    },

    removeShadowRequiredFormItem( ) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];

        // 取消高亮 专门方法 1
        if ( 'summernote_vertical' == each.item.type ) {
          $(each.$el).next('.note-editor').removeClass('shadow-required');
          continue;
        }

        // 取消高亮 专门方法 2
        if('phone_verified_vertical' == each.item.type) {
          each.shadowRequired(false);
          continue;
        }

        // 取消高亮 通用方法
        each.$el.classList.remove('shadow-required');
      }
    },

    // 参数校验
    validation() {
      if ( !this.ticketTaskFormData ) {
        console.log('#118 this.ticketTaskFormData = ', this.ticketTaskFormData);
        return true;
      }

      this.removeShadowRequiredFormItem();

      // 非空校验
      for( var i=0; i < this.ticketTaskFormData.length; i++ ) {
        var field = this.ticketTaskFormData[i];
        if('true' == field.required) {
          var value = this.properties[field.id];
          if ( !value || '<p><br></p>' == value ) {
            console.log('#271 value=', value, 'field=', field, 'this.properties=', this.properties);

            _message(field.name + '(' + field.id + ') 是必填的');

            // 高亮未填写的必填项
            this.shadowRequiredFormItem(field.id);
            return false;
          }
        }
      }

      // 各类型各自校验
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for( var i=0; i < len; i++ ) {
        if(!this.$refs.ticketTaskFormItem[i].validation()) {
          return false;
        }
      }

      return true;
    },

    copyMerchantOrder_order(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var _order = each.$children[0].order;
          var txt = _order.code + '(' + _order.id + ')';
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyMerchantOrder_merchant(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var _order = each.$children[0].order;
          var txt = _order.merchantName + '(' + _order.merchantCode + ',' + _order.merchantId + ')';
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyMerchantOrder_shop(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var _order = each.$children[0].order;
          var txt = _order.shopName + '(' + _order.shopId + ')';
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyMerchantOrder(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var txt = each.$children[0].orderLabel_1(each.$children[0].order);
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyMerchant(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var merchant = each.$children[0].merchant;
          var txt = merchant.name + "(" + merchant.code + ")";
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyShop(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var shop = each.$children[0].shop;
          var txt = shop.name + "(" + shop.id + ")";
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    copyOrder(e) {
      var len = this.$refs.ticketTaskFormItem ? this.$refs.ticketTaskFormItem.length : 0;

      for (var i = 0; i < len; i++) {
        var each = this.$refs.ticketTaskFormItem[i];
        if(e.id == each.item.id) {
          var order = each.$children[0].order;
          var txt = order.code + "(" + order.id + ")";
          this.writeToClipboard( txt );

          _message('已复制到剪贴板 ' + txt);
          return;
        }
      }
    },

    goPeople() {
      var _url = '/studyManage/primePeople?orderId=' + this.$route.query.orderId;
      console.log("#118 goPeople, _url=" + _url);
      window.open(_url);
    },

    goStudy() {
      var _url = '/studyManage/studyPlan?id=' + this.$route.query.orderId;
      console.log("#124 goStudy, _url=" + _url);
      window.open(_url);
    },

    ifHasVisibleFormType() {
      for ( var i = 0; i < this.ticketTaskFormData.length; i++ ) {
        if ( 'allow_deny' != this.ticketTaskFormData[i].type ) {
          this.hasVisibleFormType = true;
          break;
        }
      }
    },

    submitAssignToWorkflow() {
      this.$emit('submitAssignToWorkflow', null);
    },

    submitDeny() {
      this.properties.deny = 'true';
      this.properties.allow = 'false';

      this.submit_1();
    },

    submitAllow() {
      this.properties.allow = 'true';
      this.properties.deny = 'false';

      this.submit_1();
    },

    submit_1() {
      var _this = this;
      sdk.TicketWorkflowApi().submitTaskFormData({
        ticketNo : _this.ticketNo,
        properties : _this.properties
      }).then(res => {
        _this.$emit('afterPost', null);
        _this.properties = {};
      }, err => {
        console.log('#241 ', err);
        _message('#242 ' + JSON.stringify(err));
      });
    },

    listStartFormPropertyByWorkflowId(workflowId) {
      // console.log('#218 listStartFormPropertyByWorkflowId', workflowId);

      var _this = this;

      sdk.TicketWorkflowApi().listStartFormPropertyByWorkflowId({
        workflowId : workflowId
      }).then(res => {
        if( !!res ) {
          _this.ticketTaskFormData = res;
          _this.ifHasAllowDeny();
        }
      });
    },

    listStartFormPropertyByTemplateId(templateId) {
      var _this = this;

      sdk.TicketWorkflowApi().listStartFormPropertyByTemplateId({
        templateId : templateId
      }).then(res => {
        if( !!res ) {
          _this.ticketTaskFormData = res;
          _this.ifHasAllowDeny();
        }
      });
    },

    listFirstFormPropertyByTicketNo( ticketNo_2 ) {
      var _this = this;

      sdk.TicketWorkflowApi().listFirstFormPropertyByTicketNo({
        ticketNo : ticketNo_2
      }).then(res => {
        console.log('#397 listFirstFormPropertyByTicketNo', res);

        if( !!res ) {
          _this.ticketTaskFormData = res;

          res.forEach(e => {
            _this.properties[e.id] = _this.parsePropertyValue(e);
          });

          // 变更前的值
          _this.propertiesBefore = JSON.parse(JSON.stringify(_this.properties));

          _this.ifHasAllowDeny();
        }
      });
    },

    listUserTaskFormPropertyByTicketNo( _ticketNo ) {
      var _this = this;

      sdk.TicketWorkflowApi().listUserTaskFormPropertyByTicketNo({
        ticketNo : _ticketNo
      }).then(res => {
        if( !!res ) {
          _this.ticketTaskFormData = res;
        }

        _this.ifHasAllowDeny();
        _this.ifHasVisibleFormType();
      });
    }
  }
};
</script>

<style>
  @import '../../assets/style/ticket_form_item.css';
</style>



// WEBPACK FOOTER //
// src/components/ticket/TicketTaskForm.vue